import { useContext, useEffect, useState } from "react";

import { AppContext } from "../../../core/context/appContextProvider";
import { GET_PURCHASE_TRANSACTION_LIST_ERROR } from "../../../pages/fund/InvestmentTransactions/InvestmentTransactionList.constants";
import { getPortfolioCompanyFilterList } from "../../../services/filters.service";
import { getInvestmentTransactions } from "../../../services/investmentTransaction.service";
import { GENERIC_ERROR_MESSAGE } from "../../../utils/constants/text.constants";
import { DateTimeFormat } from "../../../utils/helpers/format.helper";
import { useEffectAsync } from "../../../utils/hooks/useEffectAsync.hook";
import { PortfolioCompanySimple } from "../../../utils/types/portfolioCompany.type";

export const usePurchaseTransactionFilterEffect = (refetch: boolean) => {
  const { informationAlert } = useContext(AppContext);
  const [purchaseTransactionList, setPurchaseTransactionList] = useState<PortfolioCompanySimple[]>();
  const [loading, setLoading] = useState(false);

  const fetchPurchaseTransactionFilterList = async (isCanceled?: () => boolean) => {
    setLoading(true);
    try {
      if (isCanceled?.()) return;

      const purchaseTransactionListResponse = await getInvestmentTransactions();

      const purchaseTransactions = purchaseTransactionListResponse.items.map((purchase: any) => {
        return {
          id: purchase.id,
          name: `${purchase.fund.name} - ${purchase.portfolioCompany.name} - ${purchase.securityType} - ${DateTimeFormat.shortDateString(purchase.date)} - ${purchase.name}`
        };
      }).sort();

      setPurchaseTransactionList(purchaseTransactions);
    } catch (e) {
      informationAlert(GET_PURCHASE_TRANSACTION_LIST_ERROR, "error");
    }
    setLoading(false);
  };

  useEffectAsync(async (isCanceled) => {
    await fetchPurchaseTransactionFilterList(isCanceled);
  }, []);

  return {
    purchaseTransactionList,
    loading,
  };
};

export default usePurchaseTransactionFilterEffect;

